import { render, staticRenderFns } from "./accessControl.vue?vue&type=template&id=634b5992&scoped=true&"
import script from "./accessControl.vue?vue&type=script&lang=js&"
export * from "./accessControl.vue?vue&type=script&lang=js&"
import style0 from "./accessControl.vue?vue&type=style&index=0&id=634b5992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b5992",
  null
  
)

export default component.exports